<template>
  <div class="button-back" v-on:click="backButton"><a href="javascript:void(0);"><i class="fas fa-backward"></i> {{$t('common.buttons.backButton')}}</a></div>
</template>

<script>
/* eslint-disable */
import EventBus from "../assets/js/eventBus"
export default {
  /* 
  * Name of component
  */
  name: 'BackButton',
  /* 
  * Get data from parent component
  */
  props: {
    data: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      default: "home",
      required: false
    },
    typeBack: {
      type: String,
      default: 'page',
      required: false
    }
  },
  /* 
  * Methods
  */
  methods: {
    backButton: function() {
      if (this.typeBack == 'page') {
        this.$router.push({ name: this.name, params: this.data});
      } else {
        EventBus.$emit('back-button', this.data);
      }
    }
  }
};
</script>